import { formatInTimeZone } from 'date-fns-tz'
import z from 'zod'

export const monthStartString = z
  .string()
  .date()
  .transform((v) => formatInTimeZone(v, 'UTC', 'yyyy-MM-01'))

export const monthIndex = z.coerce.number().int().min(1).max(12)
